<template>
  <div class="drug-intruction">
    <ph-search
      v-model="searchWrold"
      @keySearch="keySearch"
      field-type="search"
      placeholder="输入搜索"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
      class="drug-intruction-list"
    >
      <div
        v-for="item in list"
        :key="item.id"
        @click="gotoDetail(item.id)"
        class="drug-intruction-list-item"
      >
        {{ item.drugName }}
        <van-icon name="arrow" />
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchWrold: "",
      list: [],
      finished: false,
      currentPage: 1
    };
  },
  created() {},
  methods: {
    loadList(keyWrod) {
      this.$http
        .post(
          this.$api.OTHER_DRUG_INTRUCTION_LIST,
          {
            drugName: keyWrod,
            pageNum: this.currentPage,
            pageSize: 10
          },
          false
        )
        .then(res => {
          if (res.pageNum === 1) {
            this.list = res.list;
          } else {
            this.list = this.list.concat(res.list);
          }
          this.currentPage = res.nextPage;
          this.loading = false;
          this.finished = !res.hasNextPage;
        });
    },
    onLoad() {
      this.loadList();
    },
    keySearch() {
      this.currentPage = 1;
      this.loadList(this.searchWrold);
    },
    gotoDetail(id) {
      this.$router.push({
        name: "drug-intruction-detail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang="less">
.drug-intruction {
  height: 100%;
  overflow: hidden;
  &-list {
    height: calc(100% - 5rem);
    overflow: scroll;
    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 4rem;
      padding: 0 1rem;
      border-bottom: 1px solid @primary-gray;
    }
  }
}
</style>
